import { useState } from "react";
import "./Screens.css";
import AddTraspButton from "../firstTimeUserExperience/commonCom/AddTraspButton";
import { GetImages } from "../../utils/GetImages";
import AddButtonWithArrow from "../firstTimeUserExperience/commonCom/AddButtonWithArrow";
import { CustomInputTextArea } from "../common/formControls";
import EmptyState from "../../newComponents/emptystate";
import ActionMenu from "../../newComponents/actionMenus/action-menu";
import DateHelper from "../../utils/DateHelper";
import notesFileIcon from "../../assets/notesFileIcon.svg";


const AddNote = ({ onClose, type, onSave, toggle, edit = true, setAddNote }) => {
  const [note, setNote] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [noteContent, setNoteContent] = useState(toggle?.notes || "");
  const handleSaveClick = (e) => {
    e.preventDefault()
    setNoteContent(note);
    onSave(note, type, toggle, editMode ? "Note Edited successfully" : "Note Added successfully");
    setNote("");
    setEditMode(false);
    // onClose();
  };

  const handleEditClick = () => {
    setEditMode(true);
    setNote(noteContent);
  };

  const handleDeleteClick = () => {
    setNoteContent("");
    onSave("", type, toggle, "Note Deleted successfully");
    setEditMode(false);
  };

  return ( <>
      <div className="approved-app-form">
        <div className="InnerBody NotesBody justify-content-start">
            <form onSubmit={handleSaveClick}>
              <CustomInputTextArea
                name="answer"
                label="Note"
                placeholder="Add note here..."
                required
                isFormControl
                value={note}
                onChange={(e) => setNote(e.target.value)}
                isError={false}
                errorMessages="Add required "
                myClassName="normal_text black w-100 mb-3 py-3 "
                rows={2}
                maxLength={250}
              />
              <div className="NotesButton mb-4">
                <AddButtonWithArrow
                type="submit"
                  buttonname="Add Note"
                  // onClick={handleSaveClick}
                  minWidth={"fit-content"}
                />
                <AddTraspButton
                  type="button"
                  border={true}
                  onClick={() => {
                    setEditMode(false);
                    setAddNote(false)
                    setNote("");
                  }}
                  bname="Cancel"
                  width="fit-content"
                />
              </div>  
              </form>
              { !noteContent ? (
                <EmptyState
                  heading={"No Notes Found"}
                  bodytext={""}
                  icon={notesFileIcon}
                  isButton={false}
                  isBorder={false}
                  />

           ) : (
            <div className="displayNote">
              <p className="normal_text black">{noteContent}</p>
                <div className="displayNote-footer">
                   <div className="d-flex gap-2 align-items-center"> 
                  <p className="sub_text black">{toggle?.reviewedBy}</p>
                  <div className="divider" ></div>
                  <p className="sub_text black">{ DateHelper.formatDateonly(toggle?.reviewedTimeStamp)}</p>
                 </div>
                   <ActionMenu
                  menuItems={[
                    { label: "Edit", icon: GetImages.BlackPencil, action:  handleEditClick} 
                    , { isDivider: true },
                    { label: "Delete", icon: GetImages.BlackDelete, action:handleDeleteClick } 
                  ]}
                  trigger={
                    <button className="action-button" aria-label="More options">
                      <img
                        src={GetImages.dropdownIcon}
                        alt="More options"
                        width={20}
                        height={20}
                        className="action-icon"
                      />
                    </button>
                  }
                />
                 </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AddNote;

